<template>
  <div class="full">
    <div :id="`mapOnlyResult-${current}`" class="full"></div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations } from "vuex";
import { IC_LIST_BEFORE, IC_LIST_AFTER } from "../../const.js";

const HACHIOUJI = new window.google.maps.LatLng(
  "35.64076604201434",
  "139.24668990833808",
);

const OHTSUKI = new window.google.maps.LatLng(
  "35.611605848542126",
  "138.93244394549106",
);

export default {
  name: "GoogleMap",
  props: {
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState([
      "DepLatLng",
      "DesLatLng",
      "search",
      "dropDestionaton",
      "currentPageName",
    ]),
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
    currentDropDestionaton() {
      if (this.current === "RouteSearch") {
        return this.dropDestionaton.dropspot;
      } else if (this.current === "MyPage") {
        return this.dropDestionaton.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.dropDestionaton.jyutai;
      }
    },
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "MyPage") {
        return this.search.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentSearchDep() {
      if (this.currentSearch.departure === "現在地") {
        return this.currentDepLatLng;
      }
      return this.currentSearch.departure;
    },
    currentSearchDes() {
      if (this.currentSearch.destination === "現在地") {
        return this.currentDesLatLng;
      }
      return this.currentSearch.destination;
    },
  },
  data() {
    return {
      element: null,
      latlng: null,
      mapOptions: null,
      map: null,
      routeMarkers: [],
    };
  },
  methods: {
    ...mapMutations(["setLastRoute", "loadingStartMini", "loadingEndMini"]),
    loadMap() {
      this.element = document.getElementById(`mapOnlyResult-${this.current}`);
      this.latlng = new window.google.maps.LatLng(36.65, 138.18);
      this.mapOptions = {
        mapId: "75847128c63f5e96",
        zoom: 12,
        center: this.latlng,
        gestureHandling: "greedy",
        scaleControl: false,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      };
      this.map = new window.google.maps.Map(this.element, this.mapOptions);
      const trafficLayer = new window.google.maps.TrafficLayer();
      trafficLayer.setMap(this.map);
      this.loadingEndMini();
    },
    setDefaultMarker(position) {
      let marker = new window.google.maps.Marker({
        position,
        map: this.map,
      });
      this.routeMarkers.push(marker);
    },
    convertStartTime() {
      const now = new Date(this.currentSearch.departureTime);
      return now;
    },
    async searchRoute() {
      this.loadingStartMini();
      this.setDefaultMarker(this.currentDepLatLng);
      if (this.currentDropDestionaton) {
        this.setDefaultMarker(this.currentDropDestionaton.latlng);
      }
      this.setDefaultMarker(this.currentDesLatLng);
      let loadingEndMini = this.loadingEndMini;
      var directionsService = new window.google.maps.DirectionsService();
      let setLastRoute = this.setLastRoute;
      var directionsDisplay = new window.google.maps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true,
      });
      if (this.currentSearch.departure !== this.currentSearch.destination) {
        // 出発地と目的地がある
        if (this.currentDropDestionaton) {
          // 立ち寄りする
          let time = this.currentSearch
            ? new Date(this.currentSearch.departureTime)
            : new Date();

          if (time < new Date()) {
            time = new Date();
          }
          if (this.current === "RouteSearch") {
            // 観光のときは、立ち寄り箇所は『目的地側』
            const response = await directionsService.route({
              origin: this.currentSearchDep,
              destination: this.currentSearchDes,
              waypoints: [{ location: this.currentDropDestionaton.latlng }],
              travelMode: window.google.maps.TravelMode.DRIVING,
              drivingOptions: {
                departureTime: time,
                trafficModel: "bestguess",
              },
            });

            let resultDuration = response.routes[0].legs[0].duration.value;
            let alltimeDuration =
              resultDuration + this.currentDropDestionaton.stayTime;

            const text = JSON.stringify(response);
            if (
              Number(this.currentDesLatLng.lng()) > Number(HACHIOUJI.lng()) &&
              text.indexOf("中央自動車道") !== 1 &&
              IC_LIST_BEFORE.some((item) => text.indexOf(item) !== -1) &&
              IC_LIST_AFTER.some((item) => text.indexOf(item) !== -1)
            ) {
              let time = this.currentSearch
                ? new Date(this.currentSearch.departureTime)
                : new Date();

              if (time < new Date()) {
                time = new Date();
              }
              let durationSum = 0;

              const target = time;
              const result = await directionsService.route({
                origin: this.currentSearchDep,
                destination: OHTSUKI,
                travelMode: window.google.maps.TravelMode.DRIVING,
                drivingOptions: {
                  departureTime: target,
                  trafficModel: "bestguess",
                },
              });

              target.setSeconds(
                target.getSeconds() +
                  result.routes[0].legs[0].duration_in_traffic.value,
              );

              durationSum = result.routes[0].legs[0].duration_in_traffic.value;

              // 現在とtargetの間の分数の差を求める
              const diff = Math.round(
                (target.getTime() - new Date().getTime()) / 1000 / 60,
              );
              let num = Math.round(diff / 5);
              if (num > 65) {
                num = 60;
              }

              const result2 = await axios.get(
                "https://predict.traveltime.jp/t6hegs/?t=rct&acc=0",
              );

              const tyuoudo_min = result2.data.data[0].result[num];
              target.setMinutes(target.getMinutes() + tyuoudo_min);
              durationSum = durationSum + tyuoudo_min * 60;

              const result3 = await directionsService.route({
                origin: HACHIOUJI,
                destination: this.currentDropDestionaton.latlng,
                travelMode: window.google.maps.TravelMode.DRIVING,
                drivingOptions: {
                  departureTime: target,
                  trafficModel: "bestguess",
                },
              });
              target.setSeconds(
                target.getSeconds() +
                  result3.routes[0].legs[0].duration_in_traffic.value +
                  this.currentDropDestionaton.stayTime,
              );
              durationSum =
                durationSum +
                result3.routes[0].legs[0].duration_in_traffic.value;

              const result4 = await directionsService.route({
                origin: this.currentDropDestionaton.latlng,
                destination: this.currentDesLatLng,
                travelMode: window.google.maps.TravelMode.DRIVING,
                drivingOptions: {
                  departureTime: target,
                  trafficModel: "bestguess",
                },
              });

              durationSum =
                durationSum +
                result4.routes[0].legs[0].duration_in_traffic.value;

              resultDuration = durationSum;
              alltimeDuration =
                durationSum + this.currentDropDestionaton.stayTime;
            }

            directionsDisplay.setDirections(response);
            setLastRoute({
              route: response,
              alltimeDuration: alltimeDuration,
              duration: resultDuration,
            });
          } else {
            // 渋滞検索のときは、立ち寄り箇所は『出発地側』
            const response = await directionsService.route({
              origin: this.currentSearchDep,
              destination: this.currentSearchDes,
              waypoints: [{ location: this.currentDropDestionaton.latlng }],
              travelMode: window.google.maps.TravelMode.DRIVING,
              drivingOptions: {
                departureTime: time,
                trafficModel: "bestguess",
              },
            });

            let resultDuration = response.routes[0].legs[0].duration.value;
            let alltimeDuration =
              resultDuration + this.currentDropDestionaton.stayTime;

            const text = JSON.stringify(response);
            if (
              Number(this.currentDesLatLng.lng()) > Number(HACHIOUJI.lng()) &&
              text.indexOf("中央自動車道") !== 1 &&
              IC_LIST_BEFORE.some((item) => text.indexOf(item) !== -1) &&
              IC_LIST_AFTER.some((item) => text.indexOf(item) !== -1)
            ) {
              let time = this.currentSearch
                ? new Date(this.currentSearch.departureTime)
                : new Date();

              if (time < new Date()) {
                time = new Date();
              }
              let durationSum = 0;

              const target = time;
              const result = await directionsService.route({
                origin: this.currentSearchDep,
                destination: this.currentDropDestionaton.latlng,
                travelMode: window.google.maps.TravelMode.DRIVING,
                drivingOptions: {
                  departureTime: target,
                  trafficModel: "bestguess",
                },
              });

              target.setSeconds(
                target.getSeconds() +
                  result.routes[0].legs[0].duration_in_traffic.value,
              );

              durationSum = result.routes[0].legs[0].duration_in_traffic.value;

              const result2 = await directionsService.route({
                origin: this.currentDropDestionaton.latlng,
                destination: OHTSUKI,
                travelMode: window.google.maps.TravelMode.DRIVING,
                drivingOptions: {
                  departureTime: target,
                  trafficModel: "bestguess",
                },
              });
              target.setSeconds(
                target.getSeconds() +
                  result2.routes[0].legs[0].duration_in_traffic.value +
                  this.currentDropDestionaton.stayTime,
              );
              durationSum =
                durationSum +
                result2.routes[0].legs[0].duration_in_traffic.value;

              // 現在とtargetの間の分数の差を求める
              const diff = Math.round(
                (target.getTime() - new Date().getTime()) / 1000 / 60,
              );
              let num = Math.round(diff / 5);
              if (num > 65) {
                num = 60;
              }

              const result3 = await axios.get(
                "https://predict.traveltime.jp/t6hegs/?t=rct&acc=0",
              );

              const tyuoudo_min = result3.data.data[0].result[num];
              target.setMinutes(target.getMinutes() + tyuoudo_min);
              durationSum = durationSum + tyuoudo_min * 60;

              const result4 = await directionsService.route({
                origin: HACHIOUJI,
                destination: this.currentSearchDes,
                travelMode: window.google.maps.TravelMode.DRIVING,
                drivingOptions: {
                  departureTime: target,
                  trafficModel: "bestguess",
                },
              });
              target.setSeconds(
                target.getSeconds() +
                  result4.routes[0].legs[0].duration_in_traffic.value +
                  this.currentDropDestionaton.stayTime,
              );
              durationSum =
                durationSum +
                result4.routes[0].legs[0].duration_in_traffic.value;

              resultDuration = durationSum;
              alltimeDuration =
                durationSum + this.currentDropDestionaton.stayTime;
            }

            directionsDisplay.setDirections(response);
            setLastRoute({
              route: response,
              alltimeDuration: alltimeDuration,
              duration: resultDuration,
            });
          }
        } else {
          // 立ち寄りしない
          let time = this.currentSearch
            ? new Date(this.currentSearch.departureTime)
            : new Date();

          if (time < new Date()) {
            time = new Date();
          }

          const response = await directionsService.route({
            origin: this.currentSearchDep,
            destination: this.currentSearchDes,
            travelMode: window.google.maps.TravelMode.DRIVING,
            drivingOptions: {
              departureTime: time,
              trafficModel: "bestguess",
            },
          });

          let resultDuration =
            response.routes[0].legs[0].duration_in_traffic.value;

          const text = JSON.stringify(response);
          if (
            Number(this.currentDesLatLng.lng()) > Number(HACHIOUJI.lng()) &&
            text.indexOf("中央自動車道") !== 1 &&
            IC_LIST_BEFORE.some((item) => text.indexOf(item) !== -1) &&
            IC_LIST_AFTER.some((item) => text.indexOf(item) !== -1)
          ) {
            let time = this.currentSearch
              ? new Date(this.currentSearch.departureTime)
              : new Date();

            if (time < new Date()) {
              time = new Date();
            }
            let durationSum = 0;
            const target = time;
            const result = await directionsService.route({
              origin: this.currentSearchDep,
              destination: OHTSUKI,
              travelMode: window.google.maps.TravelMode.DRIVING,
              drivingOptions: {
                departureTime: target,
                trafficModel: "bestguess",
              },
            });

            target.setSeconds(
              target.getSeconds() +
                result.routes[0].legs[0].duration_in_traffic.value,
            );

            durationSum = result.routes[0].legs[0].duration_in_traffic.value;

            // 現在とtargetの間の分数の差を求める
            const diff = Math.round(
              (target.getTime() - new Date().getTime()) / 1000 / 60,
            );
            let num = Math.round(diff / 5);
            if (num > 65) {
              num = 60;
            }

            const result2 = await axios.get(
              "https://predict.traveltime.jp/t6hegs/?t=rct&acc=0",
            );

            const tyuoudo_min = result2.data.data[0].result[num];
            target.setMinutes(target.getMinutes() + tyuoudo_min);
            durationSum = durationSum + tyuoudo_min * 60;

            const result3 = await directionsService.route({
              origin: HACHIOUJI,
              destination: this.currentSearchDes,
              travelMode: window.google.maps.TravelMode.DRIVING,
              drivingOptions: {
                departureTime: target,
                trafficModel: "bestguess",
              },
            });
            target.setSeconds(
              target.getSeconds() +
                result3.routes[0].legs[0].duration_in_traffic.value,
            );
            durationSum =
              durationSum + result3.routes[0].legs[0].duration_in_traffic.value;
            resultDuration = durationSum;
          }

          directionsDisplay.setDirections(response);
          setLastRoute({
            route: response,
            alltimeDuration: resultDuration,
            duration: resultDuration,
          });
        }
      } else {
        // 特定の場所に行くだけのパターン

        let time = this.currentSearch
          ? new Date(this.currentSearch.departureTime)
          : new Date();

        if (time < new Date()) {
          time = new Date();
        }

        const response = await directionsService.route({
          origin: this.currentSearchDep,
          destination: this.currentDropDestionaton.latlng,
          travelMode: window.google.maps.TravelMode.DRIVING,
          drivingOptions: {
            departureTime: time,
            trafficModel: "bestguess",
          },
        });

        let resultDuration =
          response.routes[0].legs[0].duration_in_traffic.value;

        const text = JSON.stringify(response);
        if (
          Number(this.currentDropDestionaton.latlng.lng()) >
            Number(HACHIOUJI.lng()) &&
          text.indexOf("中央自動車道") !== 1 &&
          IC_LIST_BEFORE.some((item) => text.indexOf(item) !== -1) &&
          IC_LIST_AFTER.some((item) => text.indexOf(item) !== -1)
        ) {
          let durationSum = 0;

          let time = this.currentSearch
            ? new Date(this.currentSearch.departureTime)
            : new Date();

          if (time < new Date()) {
            time = new Date();
          }
          const target = time;
          const result = await directionsService.route({
            origin: this.currentSearchDep,
            destination: OHTSUKI,
            travelMode: window.google.maps.TravelMode.DRIVING,
            drivingOptions: {
              departureTime: target,
              trafficModel: "bestguess",
            },
          });

          target.setSeconds(
            target.getSeconds() +
              result.routes[0].legs[0].duration_in_traffic.value,
          );

          durationSum = result.routes[0].legs[0].duration_in_traffic.value;

          // 現在とtargetの間の分数の差を求める
          const diff = Math.round(
            (target.getTime() - new Date().getTime()) / 1000 / 60,
          );
          let num = Math.round(diff / 5);
          if (num > 65) {
            num = 60;
          }

          const result2 = await axios.get(
            "https://predict.traveltime.jp/t6hegs/?t=rct&acc=0",
          );

          const tyuoudo_min = result2.data.data[0].result[num];
          target.setMinutes(target.getMinutes() + tyuoudo_min);
          durationSum = durationSum + tyuoudo_min * 60;

          const result3 = await directionsService.route({
            origin: HACHIOUJI,
            destination: this.currentDropDestionaton.latlng,
            travelMode: window.google.maps.TravelMode.DRIVING,
            drivingOptions: {
              departureTime: target,
              trafficModel: "bestguess",
            },
          });
          target.setSeconds(
            target.getSeconds() +
              result3.routes[0].legs[0].duration_in_traffic.value,
          );
          durationSum =
            durationSum + result3.routes[0].legs[0].duration_in_traffic.value;
          resultDuration = durationSum;
        }

        directionsDisplay.setDirections(response);
        setLastRoute({
          route: response,
          alltimeDuration: resultDuration,
          duration: resultDuration,
        });
      }
      loadingEndMini();
    },
  },
  mounted() {
    this.loadingStartMini();
    this.loadMap();
  },
  watch: {
    map: {
      immideate: true,
      handler: function () {
        this.searchRoute();
      },
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100px;
  margin: 0 auto;
  background: gray;
}
.full {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/GoogleMapOnlyResult.vue